// import CompanyLogo from "assets/images/companyLogo.svg";
// import companyBlueLogo from "assets/images/blueLogo.svg"
// import Favicon from "assets/images/favicon.ico";


// export const companyDetails = {
//     companyName: "RentnGo-Frontdesk",
//     favicon: Favicon,
//     companyLogo: CompanyLogo,
//     companyBlueLogo:companyBlueLogo,
// }

const getCompanyLogo = () => {
  const logoPath = process.env.REACT_APP_COMPANY_LOGO || "companyLogo.svg";
  
  // If it's an external URL (http or https), return it as-is
  if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
    return logoPath;
  }
  
  // Otherwise, try to load from local assets/images folder
  try {
    return require(`assets/images/${logoPath}`).default || require(`assets/images/${logoPath}`);
  } catch (error) {
    // Fallback to default logo if file not found
    return require('assets/images/companyLogo.svg').default || require('assets/images/companyLogo.svg');
  }
};


const getCompanyBlueLogo = () => {
  const blueLogoPath = process.env.REACT_APP_COMPANY_BLUE_LOGO || "blueLogo.svg";

  if(blueLogoPath.startsWith('http://') || blueLogoPath.startsWith('https://')) {
    return blueLogoPath;
  }
    try {
    return require(`assets/images/${blueLogoPath}`).default || require(`assets/images/${blueLogoPath}`);
  } catch (error) {
    // Fallback to default blue logo if file not found
    return require('assets/images/blueLogo.svg').default || require('assets/images/blueLogo.svg');
  }
};

const getCompanyFavicon = () => {
  const faviconPath = process.env.REACT_APP_COMPANY_FAVICON || "/favicon.ico";
  
  // If it's an external URL (http or https), return it as-is
  if (faviconPath.startsWith('http://') || faviconPath.startsWith('https://')) {
    return faviconPath;
  }
  
  // Otherwise return as local path
  return faviconPath;
};

export const companyDetails = {
    companyName: process.env.REACT_APP_COMPANY_NAME || "RentnGo-Multitenant-Frontdesk",
    favicon: getCompanyFavicon(),
    companyLogo: getCompanyLogo(),
    companyBlueLogo: getCompanyBlueLogo(),
    url: process.env.REACT_APP_B2B_API_BASE_URL
}